<template lang="pug">
  .contenedor-interno(v-on-clickaway="close")
    .title
      span Empleados
    .search
      .control
        input.input(
          type="text",
          placeholder="Buscar empleados...",
          v-model="filtro"
          @keyup.enter="selectFirst"
          @keyup.esc="close"
          ref="busqueda"
          @input="fetchSearch"
        )
    .data
      transition-group.contenedor-data(v-infinite-scroll="fetchByScroll" infinite-scroll-disabled="disabledScrollExcecute" infinite-scroll-distance="2" name="fade-smooth-two" tag="div")
        .usuario(
          v-for="(o, index) in filteredEmpleados"
          :key="'empleado_lookup_'+index"
          :class="{'is-close': !o.activo}"
          @click="seleccionarClick(o)"
        )
          .flex
            span.codigo {{ o.dni}}:
            span.nombre &nbsp;{{ o.nombre }}

          .mt-5(v-if="!o.activo && o.fechaInactivoString")
            span.name.seen.has-text-bold Inactivo desde {{o.fechaInactivoString}}
      .info-message(v-if="!isLoading & filteredEmpleados.length === 0")
        span No se encontraron coincidencias
      .is-loading.text-center(v-if="isLoading")
        span.icon
          i.fa.fa-spin.fa-spinner
      //- loading-global(v-if="isLoading" :message="'Cargando'")
      //- .info-message(v-if="!isLoading & filtro !== ''")
        span No se encontraron mas coincidencias para
          strong.tag.is-dark {{filtro}}

</template>

<script>
import { apiGet, notify } from '../util/general'
import _ from 'lodash'
import cargandoLoad   from './Component_Cargando'
export default {
  name: 'lookup_small_empleado',
  components : {
    'loading-global' : cargandoLoad
  },
  props: ['codigo', 'tipo', 'empleadosInactivos'],
  data () {
    return {
      empleados              : [],
      filteredEmpleados      : [],
      filtro                 : '',
      isLoading              : false,
      isScroll               : false,
      disabledScrollExcecute : true,
      numeroRecnum           : 0,
      noMore                 : false
    }
  },
  created () {
    this.fetch()
  },
  mounted () {
    this.$refs.busqueda.focus()
  },
  methods: {
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    },
    fetchSearch : _.debounce(function (value) {
      var vm = this
      vm.fetch()
    }, 300),
    fetch () {
      var vm = this
      vm.isLoading                = true
      vm.disabledScrollExcecute   = true
      vm.noMore                   = false
      if (!vm.isScroll) {
        vm.filteredEmpleados = []
        vm.numeroRecnum = 0
      }
      var obj = {
        filtro       : vm.filtro,
        numeroRecnum : vm.numeroRecnum
      }
      if (typeof vm.tipo !== 'undefined') {
        obj.tipo = vm.tipo
      }
      if (typeof vm.empleadosInactivos !== 'undefined') {
        obj.empleadosInactivos = vm.empleadosInactivos
      }
      apiGet(vm, '/vacaciones/empleado/active', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.filteredEmpleados.push(data.lista[i])
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExcecute = true
        } else {
          vm.numeroRecnum = data.numeroRecnum
          vm.disabledScrollExcecute = false
        }

        vm.isLoading         = false
        vm.isScroll = false
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.disabledScrollExcecute = true
        vm.isScroll = false
      })
    },
    selectFirst () {
      if (this.filteredEmpleados.length === 0) {
        this.$emit('close')
      } else {
        this.$emit('selected', this.filteredEmpleados[0])
        this.$emit('close')
      }
    },
    seleccionarClick (o) {
      this.$emit('selected', o)
      this.$emit('close')
    },
    close () {
      this.$emit('close', this.filteredEmpleados[0])
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .seen
    background-color: #DA8D7D;
    padding: 0px 4px;
    margin-top: 3px;
    border-radius: 4px;
    color: #fff;
  .is-close
    background-color: #ffd6d6 !important;
  .contenedor-interno
    display flex
    flex-direction column

    .title
      margin 10px 5px 5px 5px
      font-size 17px
      border-bottom 1px solid #ccc
      padding-bottom 10px
      text-align center

    .search
      padding 5px 10px

    .data
      max-height: 180px;
      overflow-y: auto;
      .contenedor-box
        >*
          transition all .5s
          width 100%
      padding 10px
      .usuario
        background: #fff;
        border-radius: 3px;
        border: 1px solid #d6dadc;
        border-bottom-color: #c4c9cc;
        -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
        box-shadow: 0 1px 6px rgba(0,0,0,.15);
        padding 10px
        margin-bottom 5px
        cursor pointer
        transition all .2s ease

        &:hover
          background-color: #edeff0;
          margin-left: 4px;
          -webkit-box-shadow: -8px 0 #959da17d;
          box-shadow: -8px 0 #959da17d;

        .nombre
          flex 1

</style>



// WEBPACK FOOTER //
// Component_Lookup_Small_Empleado.vue?6fb5ab64